// src/Dashboard/pages/user/Lexique/components/LexiqueSkeleton.jsx

import React from "react";

export default function LexiqueSkeleton() {
  return (
    <div className="grid animate-pulse gap-2 border-b border-slate-200 px-4 py-2 last:border-b-0 dark:border-slate-800 lg:grid-cols-[minmax(170px,0.85fr)_minmax(240px,1.35fr)_220px] lg:items-center">
      <div className="h-4 w-40 rounded bg-slate-200 dark:bg-slate-800" />
      <div className="h-4 w-64 max-w-full rounded bg-slate-200 dark:bg-slate-800" />
      <div className="flex gap-2 lg:justify-end">
        <div className="h-8 w-12 rounded-xl bg-slate-200 dark:bg-slate-800" />
        <div className="h-8 w-12 rounded-xl bg-slate-200 dark:bg-slate-800" />
        <div className="h-8 w-16 rounded-xl bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}